import { Typography } from '@mui/material';
import styled from 'styled-components';

export const SelectAllTypography = styled(Typography)`
	user-select: all;
`;
